import { usePatientDocumentsDownloadMutation } from "../../../../../api/patientDocuments/usePatientDocumentsDownloadMutation";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../services/UINotificationService";
import { extractApiError } from "../../../../../utilities/api";
import { getPathParams } from "../utilities";

export function useBulkDownload({ onSuccess } = {}) {
  var { tClients: t } = useAppTranslation.Clients();
  var { patientId } = getPathParams();

  var { mutateAsync, isLoading } = usePatientDocumentsDownloadMutation({
    onError: (res) => {
      var message = extractApiError(res);
      uiNotification.error(
        t([`documents.error.${message}`, "documents.error.download"]),
      );
    },
    onSuccess: (res) => {
      window.open(res.objectUrl, "_blank");
      onSuccess?.();
    },
  });

  return {
    isLoading,
    initiate: async (ids) => {
      return await mutateAsync({
        ids,
        patientId,
      });
    },
  };
}
